<template>
  <bean-table
    :key="tableKey"
    :height="null"
    size="small"
    :value="tableData"
    :columns="tableColumns"
    :stripe="false"
    :horizontal="horizontal"
    :class="{ 'table-horizontal': horizontal }"
  />
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class RankTable extends Vue {
  @Prop({ type: Boolean, default: false }) horizontal;
  @Prop({ type: Array, default: () => [] }) data;
  @Prop({ type: String, default: '' }) sortableField;
  @Prop({ type: Boolean, default: false }) isPercent;

  tableKey = 0;

  @Watch('data', { deep: true })
  onDataChange() {
    this.tableKey += 1;
  }

  get dataSorted() {
    return _.orderBy(this.data, 'rank');
  }

  get horizontalColumns() {
    return [
      {
        prop: 'index',
        label: '排名',
        width: 80,
        fixed: 'left',
        className: 'table-index-column',
      },
      ...this.dataSorted.map((item, index) => ({
        prop: `rank_${index + 1}`,
        label: String(item.rank),
        width: 120,
        renderCell: (h, context) => {
          const { value, scope: { $index } } = context.props;
          if ($index === 1) {
            if (this.isPercent) {
              return <span>{(value * 100).toFixed(2)}%</span>
            }
            return <app-locale-string value={value} />
          }
          return <span>{value}</span>;
        }
      })),
    ]
  }

  get horizontalTableData() {
    const data = [
      {
        index: '姓名',
      },
      {
        index: '数量',
      }
    ];
    this.dataSorted.forEach((item, index) => {
      _.set(data[0], `rank_${index + 1}`, item.name);
      _.set(data[1], `rank_${index + 1}`, item[this.sortableField]);
    });
    return data;
  }

  get columns() {
    return [
      {
        prop: 'rank',
        label: '排名',
        minWidth: 80,
      },
      {
        prop: 'name',
        label: '业务员',
        minWidth: 120,
      },
      {
        prop: this.sortableField,
        label: '数量',
        minWidth: 120,
        renderCell: (h, { props: { value } }) => {
          if (this.isPercent) {
            return <span>{(value * 100).toFixed(2)}%</span>
          }
          return <app-locale-string value={value} />
        }
      }
    ];
  }

  get tableData() {
    if (this.horizontal) {
      return this.horizontalTableData;
    }
    return this.dataSorted.map((item) => {
      return {
        rank: item.rank,
        name: item.name,
        [this.sortableField]: item[this.sortableField],
      }
    });
  }

  get tableColumns() {
    if (this.horizontal) {
      return this.horizontalColumns;
    }
    return this.columns;
  }
}
</script>

